import { render, staticRenderFns } from "./ReviewsSettingsCreateOrEdit.vue?vue&type=template&id=4f719227&"
import script from "./ReviewsSettingsCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./ReviewsSettingsCreateOrEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports